import { CalendarCheck, Phone } from "lucide-react";
import { SITE } from "../lib/site";
import { Link } from "react-router-dom";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      translate="no"
      lang="it"
      className="notranslate relative py-24 sm:py-32 bg-[var(--ee-ink)] text-[var(--ee-ivory)] overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-24 -right-24 w-[400px] h-[400px] rounded-full opacity-30 blur-3xl"
        style={{ background: "radial-gradient(circle, var(--ee-rose-strong) 0%, transparent 70%)" }}
      />
      <div
        aria-hidden
        className="absolute -bottom-32 -left-24 w-[420px] h-[420px] rounded-full opacity-25 blur-3xl"
        style={{ background: "radial-gradient(circle, var(--ee-taupe) 0%, transparent 70%)" }}
      />

      <div className="relative max-w-3xl mx-auto px-5 sm:px-8 text-center">
        <div
          className="ee-eyebrow justify-center"
          style={{ color: "var(--ee-rose)" }}
        >
          Prenota
        </div>
        <h2
          data-testid="final-cta-title"
          className="font-serif-display mt-5 text-[36px] sm:text-[52px] lg:text-[62px] leading-[1.06] tracking-[-0.01em]"
        >
          Prenota il tuo trattamento
          <br />
          in modo
          <em className="italic" style={{ color: "var(--ee-rose)" }}> semplice e veloce</em>.
        </h2>
        <p className="mt-6 text-[15px] sm:text-[16px] leading-[1.7] text-[var(--ee-ivory)]/70 max-w-xl mx-auto">
          Disponibilità in tempo reale qui sul sito, oppure chiamaci per
          consigli personalizzati sui trattamenti più adatti a te.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Link
            to="/prenota"
            data-testid="final-book-btn"
            className="ee-btn !bg-[var(--ee-ivory)] !text-[var(--ee-ink)] !border-[var(--ee-ivory)] hover:!bg-[var(--ee-rose-strong)] hover:!text-white hover:!border-[var(--ee-rose-strong)]"
          >
            <CalendarCheck size={16} strokeWidth={1.8} />
            Prenota online
          </Link>
          <a
            href={SITE.phoneTel}
            data-testid="final-call-btn"
            className="ee-btn !bg-transparent !text-[var(--ee-ivory)] !border-[var(--ee-ivory)]/50 hover:!bg-[var(--ee-ivory)]/10 hover:!border-[var(--ee-ivory)]"
          >
            <Phone size={16} strokeWidth={1.8} />
            Chiama ora
          </a>
        </div>
      </div>
    </section>
  );
}
